function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.356 18.736)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.817,7.152a4.508,4.508,0,0,1,3.3,1.358,4.405,4.405,0,0,1,1.358,3.245,4.444,4.444,0,0,1-1.358,3.258,4.558,4.558,0,0,1-3.3,1.357,4.634,4.634,0,0,1-4.609-4.615A4.406,4.406,0,0,1,8.566,8.509a4.4,4.4,0,0,1,3.251-1.357M3.635,3.623A11.058,11.058,0,0,0,.263,11.767a11.058,11.058,0,0,0,3.372,8.145,11.2,11.2,0,0,0,8.182,3.378,11.042,11.042,0,0,0,8.113-3.378,11.066,11.066,0,0,0,3.359-7.538c0-.208.013-.411.013-.606v-.3A11.072,11.072,0,0,0,19.93,3.623,10.982,10.982,0,0,0,11.817.258,11.137,11.137,0,0,0,3.635,3.623",
  transform: "translate(-0.263 -0.258)",
  fill: "#333"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 18.736)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.817,7.152a4.508,4.508,0,0,1,3.3,1.358,4.405,4.405,0,0,1,1.358,3.245,4.444,4.444,0,0,1-1.358,3.258,4.558,4.558,0,0,1-3.3,1.357,4.634,4.634,0,0,1-4.609-4.615A4.406,4.406,0,0,1,8.566,8.509a4.4,4.4,0,0,1,3.251-1.357M3.635,3.623A11.058,11.058,0,0,0,.263,11.767a11.058,11.058,0,0,0,3.372,8.145,11.2,11.2,0,0,0,8.182,3.378,11.042,11.042,0,0,0,8.113-3.378,11.066,11.066,0,0,0,3.359-7.538c0-.208.013-.411.013-.606v-.3A11.072,11.072,0,0,0,19.93,3.623,10.982,10.982,0,0,0,11.817.258,11.137,11.137,0,0,0,3.635,3.623",
  transform: "translate(-0.263 -0.258)",
  fill: "#333"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.817,7.152a4.508,4.508,0,0,1,3.3,1.358,4.405,4.405,0,0,1,1.358,3.245,4.444,4.444,0,0,1-1.358,3.258,4.558,4.558,0,0,1-3.3,1.357,4.634,4.634,0,0,1-4.609-4.615A4.406,4.406,0,0,1,8.566,8.509a4.4,4.4,0,0,1,3.251-1.357M3.635,3.623A11.058,11.058,0,0,0,.263,11.767a11.058,11.058,0,0,0,3.372,8.145,11.2,11.2,0,0,0,8.182,3.378,11.042,11.042,0,0,0,8.113-3.378,11.066,11.066,0,0,0,3.359-7.538c0-.208.013-.411.013-.606v-.3A11.072,11.072,0,0,0,19.93,3.623,10.982,10.982,0,0,0,11.817.258,11.137,11.137,0,0,0,3.635,3.623",
  transform: "translate(-0.263 -0.258)",
  fill: "#333"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.356 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.817,7.152a4.508,4.508,0,0,1,3.3,1.358,4.405,4.405,0,0,1,1.358,3.245,4.444,4.444,0,0,1-1.358,3.258,4.558,4.558,0,0,1-3.3,1.357,4.634,4.634,0,0,1-4.609-4.615A4.406,4.406,0,0,1,8.566,8.509a4.4,4.4,0,0,1,3.251-1.357M3.635,3.623A11.058,11.058,0,0,0,.263,11.767a11.058,11.058,0,0,0,3.372,8.145,11.2,11.2,0,0,0,8.182,3.378,11.042,11.042,0,0,0,8.113-3.378,11.066,11.066,0,0,0,3.359-7.538c0-.208.013-.411.013-.606v-.3A11.072,11.072,0,0,0,19.93,3.623,10.982,10.982,0,0,0,11.817.258,11.137,11.137,0,0,0,3.635,3.623",
  transform: "translate(-0.263 -0.258)",
  fill: "#333"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.745 18.736)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.563,7.2a4.5,4.5,0,0,1,3.316,1.307,4.436,4.436,0,0,1,1.352,3.252,4.44,4.44,0,0,1-1.352,3.259,4.593,4.593,0,0,1-3.316,1.358,4.625,4.625,0,0,1-4.591-4.617A4.436,4.436,0,0,1,8.323,8.505,4.348,4.348,0,0,1,11.563,7.2M3.4,3.624A11.061,11.061,0,0,0,.025,11.77,11.061,11.061,0,0,0,3.4,19.917a11.172,11.172,0,0,0,8.166,3.372,11.047,11.047,0,0,0,8.128-3.372,11.041,11.041,0,0,0,3.36-7.54c0-.209.013-.411.013-.606v-.3a11.049,11.049,0,0,0-3.372-7.85A10.993,10.993,0,0,0,11.563.258,11.118,11.118,0,0,0,3.4,3.624",
  transform: "translate(-0.025 -0.258)",
  fill: "#333"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.745 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.563,7.2a4.5,4.5,0,0,1,3.316,1.307,4.436,4.436,0,0,1,1.352,3.252,4.44,4.44,0,0,1-1.352,3.259,4.593,4.593,0,0,1-3.316,1.358,4.625,4.625,0,0,1-4.591-4.617A4.436,4.436,0,0,1,8.323,8.505,4.348,4.348,0,0,1,11.563,7.2M3.4,3.624A11.061,11.061,0,0,0,.025,11.77,11.061,11.061,0,0,0,3.4,19.917a11.172,11.172,0,0,0,8.166,3.372,11.047,11.047,0,0,0,8.128-3.372,11.041,11.041,0,0,0,3.36-7.54c0-.209.013-.411.013-.606v-.3a11.049,11.049,0,0,0-3.372-7.85A10.993,10.993,0,0,0,11.563.258,11.118,11.118,0,0,0,3.4,3.624",
  transform: "translate(-0.025 -0.258)",
  fill: "#333"
}));

var Svg888Dark = function Svg888Dark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20pt",
    height: "20pt",
    viewBox: "0 0 71.784 41.767",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg888Dark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/888-dark.f51e99ef.svg";
export { ForwardRef as ReactComponent };